// «О платформе» — pagina care spune ce e ScalpScreener, pentru cine intră prima dată.
//
// Structura urmează pagina de prezentare a ScalpX: patru blocuri mari — comunitatea,
// screener-ul, antrenorul, tarifele —, fiecare cu un titlu, o frază care explică rostul
// şi carduri cu funcţii, ilustrate.
//
// Două lucruri sunt ale noastre, nu ale lor, şi intenţionat aşa:
//
// * **capturile sunt din aplicaţia noastră**. Pozele lor arată produsul lor; puse aici
//   ar promite funcţii pe care nu le avem (camere vocale, stream-uri, discount 40%) şi
//   ar înfăţişa altă interfaţă decât cea în care ajunge omul după ce apasă „Начать";
// * **textul descrie doar ce există**. Alertele, de pildă, ajung în platformă, nu în
//   Telegram — botul încă n-are token —, deci aşa scrie. O pagină de prezentare care
//   promite ce nu livrezi se întoarce împotriva ta la primul clic.

import { el } from '../core/util.js';
import { icon } from '../ui/icons.js';
import { settings, market } from '../core/state.js';
import { session } from '../core/session.js';
import { openAuth } from '../ui/auth-modal.js';

/** Cele trei părţi ale platformei, pe scurt, în capul paginii. */
const PILONI = [
  {
    eticheta: 'Основа платформы', ico: 'comments', titlu: 'Сообщество',
    text: 'Общий чат с графиками прямо из скринера, торговые идеи с входом и стопом, '
      + 'рейтинг за идеи, которые отработали, и журнал сделок. Под своим именем — '
      + 'и с историей, которую видно всем.',
    href: '#community',
  },
  {
    eticheta: 'Инструмент внутри', ico: 'chartLine', titlu: 'Скринер',
    text: '6 бирж, десятки живых графиков одновременно, радар объёмов, терминал '
      + 'плотностей, автопоиск формаций и календарь листингов. Работает без аккаунта.',
    href: '#screener',
  },
  {
    eticheta: 'Инструмент внутри', ico: 'clockHistory', titlu: 'Тренажёр',
    text: 'Реальный участок истории без подсказок: определите направление, сервер '
      + 'раскроет продолжение. Точность копится в вашей статистике.',
    href: '#preplay',
  },
];

const COMUNITATE = [
  ['Общий чат', 'Живое обсуждение с реакциями. График из скринера отправляется в чат '
    + 'одной кнопкой — обсуждать сетап проще, когда все смотрят на одну и ту же картинку.',
    'scr-chat'],
  ['Торговые идеи', 'Публикация с точкой входа, целью и стопом. Исход решает голосование '
    + 'участников, а цену отслеживает сервер: отработала идея — автор получает рейтинг.',
    'scr-ideas'],
  ['Торговые отчёты', 'Журнал дня: что делали, что получилось, что нет. Дисциплина '
    + 'начинается с записи, а не с намерения.', null],
  ['Рейтинг и ранги', 'От «Новичка» до «Гуру». Растёт за идеи, которые отработали, '
    + 'и падает за те, что нет. Лидеры — на общей доске.', 'scr-leaderboard'],
  ['Личный профиль', 'Ваши идеи, винрейт, прогресс до следующего ранга — видно всем. '
    + 'Репутация, которую нельзя купить.', null],
  ['Модерация', 'Владелец, админы и модераторы. Правила сообщества написаны и открыты — '
    + 'без рекламы, продажи сигналов и скама.', null],
];

const SCREENER = [
  ['6 бирж · фьючерсы и спот', 'Binance, Bybit, OKX, Bitget, Gate и MEXC. Переключение '
    + 'биржи в один клик, цены обновляются в реальном времени — браузер берёт данные '
    + 'прямо у биржи, без посредника.', null],
  ['Сетка живых графиков', 'Десятки графиков одновременно, 2–4 колонки, свои фильтры по '
    + 'обороту, волатильности и изменению цены, закладки и сортировки.', 'scr-grid'],
  ['Радар объёмов', 'Монеты, в которые прямо сейчас заходят деньги. И главное — кто '
    + 'заходит: если оборот растёт быстрее числа сделок, это крупный игрок; если '
    + 'наоборот — толпа мелких ордеров.', 'scr-radar'],
  ['Терминал плотностей', 'Крупные лимитные заявки в стакане: видно, где стоит стена, '
    + 'до того как цена до неё дойдёт.', 'scr-density'],
  ['Формации', 'Сканер сам находит пробои, ложные пробои, отскоки и сжатия — с оценкой '
    + 'и разбором, из чего она сложилась: закрытие за уровнем в ATR, объём к среднему, '
    + 'число касаний. Можно проверить, а не просто поверить.', 'scr-formations'],
  ['Разметка, уровни и алерты', 'Трендовые, уровни, Фибоначчи, линейка. Автоматические '
    + 'уровни по числу касаний. Ценовые оповещения проверяются на сервере и приходят '
    + 'в уведомления платформы.', null],
];

const ANTRENOR = [
  ['Реальная история', 'Случайная монета и случайный момент из прошлого. Вы видите только '
    + 'то, что было до него — продолжение лежит на сервере и не приходит в браузер, '
    + 'пока вы не ответите.', 'scr-preplay'],
  ['Без подсказок', 'Задача одна и честная: куда пойдёт цена. Никаких индикаторов-'
    + 'помощников и никакой возможности подсмотреть в консоли.', null],
  ['Ваша статистика', 'Каждая попытка записывается. Точность видна в профиле и растёт '
    + 'вместе с рейтингом — или не растёт, и это тоже полезно знать.', null],
];

const TARIFE = [
  {
    titlu: 'Скринер', pret: 'Бесплатно', sub: 'без аккаунта',
    puncte: ['6 бирж, живые графики без ограничений', 'Радар объёмов, плотности, формации',
      'Календарь листингов и техданные'],
    actiune: ['Открыть скринер', () => { location.href = '/screener/coins/'; }],
  },
  {
    titlu: 'Сообщество', pret: 'Бесплатно', sub: 'нужен аккаунт', evidentiat: true,
    puncte: ['Чат, идеи, отчёты, рейтинг', 'Профиль с публичной историей',
      'Подтверждение почты — и всё'],
    actiune: ['Создать аккаунт', () => openAuth({ mode: 'register' })],
  },
  {
    titlu: 'Тренажёр', pret: 'Бесплатно', sub: 'нужен аккаунт',
    puncte: ['Реальные участки истории', 'Статистика попыток', 'Без ограничений по числу'],
    actiune: ['Открыть тренажёр', () => { location.href = '/preplay/'; }],
  },
];

/**
 * Cifrele din capul paginii. Cea de monede se citeşte din piaţa încărcată, nu e scrisă
 * de mână: o pagină de prezentare care spune „500+" când în listă sunt 300 minte chiar
 * la primul ecran pe care îl deschide omul.
 */
function cifre() {
  const monede = market.list?.().length || 0;
  return [
    ['6', 'бирж'],
    ['2', 'рынка · фьючерсы и спот'],
    [monede ? `${Math.floor(monede / 50) * 50}+` : '—', 'монет в работе'],
    ['0', 'рублей за всё'],
  ];
}

const poza = (nume, alt) => (nume
  ? el('img', { class: 'ab-shot', src: `/static/img/landing/${nume}.webp`, alt, loading: 'lazy' })
  : null);

/** Un card de funcţie: titlu, explicaţie şi, unde ajută, o captură. */
function cardFunctie([titlu, text, imagine]) {
  return el('article', { class: `ab-feat${imagine ? ' has-shot' : ''}` }, [
    el('h4', { class: 'ab-feat-t', text: titlu }),
    el('p', { class: 'ab-feat-x', text }),
    poza(imagine, titlu),
  ]);
}

function bloc({ id, numar, eticheta, titlu, intro, functii }) {
  return el('section', { class: 'ab-block', id }, [
    el('div', { class: 'ab-block-head' }, [
      el('span', { class: 'ab-num', text: numar }),
      el('span', { class: 'ab-tag', text: eticheta }),
    ]),
    el('h2', { class: 'ab-h2', text: titlu }),
    el('p', { class: 'ab-intro', text: intro }),
    el('div', { class: 'ab-feats' }, functii.map(cardFunctie)),
  ]);
}

export class AboutSection {
  constructor(app) {
    this.app = app;
  }

  mount(host) {
    this.root = el('div', { class: 'ab-section' }, [
      // Fundalul: trei pete de lumină care plutesc încet şi o grilă stinsă. Sunt pur
      // decorative, deci `aria-hidden` — un cititor de ecran n-are ce anunţa aici.
      el('div', { class: 'ab-bg', 'aria-hidden': 'true' }, [
        el('span', { class: 'ab-orb o1' }),
        el('span', { class: 'ab-orb o2' }),
        el('span', { class: 'ab-orb o3' }),
        el('span', { class: 'ab-grid' }),
      ]),

      el('div', { class: 'ab-doc' }, [

        el('header', { class: 'ab-hero' }, [
          el('span', { class: 'ab-mark' }, [
            el('span', { class: 'tabs-home-s', text: 'S' }),
            el('span', { class: 'tabs-home-x', text: 'X' }),
          ]),
          el('h1', { class: 'ab-h1', text: 'Не просто скринер — среда для трейдера' }),
          el('p', { class: 'ab-lead' }, [
            el('span', {
              text: 'Инструмент, сообщество и тренажёр под одним аккаунтом. Скринер '
                + 'работает без регистрации; аккаунт нужен, чтобы писать и публиковать — '
                + 'под своим именем.',
            }),
          ]),
          el('div', { class: 'ab-hero-act' }, [
            el('button', {
              class: 'btn primary',
              text: session.authenticated ? 'Открыть скринер' : 'Начать бесплатно',
              onclick: () => (session.authenticated
                ? (location.href = '/screener/coins/')
                : openAuth({ mode: 'register' })),
            }),
            el('button', {
              class: 'btn', text: 'Тарифы',
              onclick: () => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' }),
            }),
          ]),
          el('img', { class: 'ab-hero-shot', src: '/static/img/landing/scr-dashboard.webp', alt: 'Дашборд' }),
        ]),

        el('div', { class: 'ab-stats' }, cifre().map(([n, eticheta]) => el('div', { class: 'ab-stat' }, [
          el('span', { class: 'ab-stat-n', text: n, dataset: { tinta: n } }),
          el('span', { class: 'ab-stat-x', text: eticheta }),
        ]))),

        el('div', { class: 'ab-pillars' }, PILONI.map((p) => el('button', {
          class: 'ab-pillar',
          onclick: () => document.querySelector(p.href)?.scrollIntoView({ behavior: 'smooth' }),
        }, [
          el('span', { class: 'ab-pillar-tag', text: p.eticheta }),
          el('span', { class: 'ab-pillar-t' }, [icon(p.ico, 15), el('span', { text: p.titlu })]),
          el('span', { class: 'ab-pillar-x', text: p.text }),
          el('span', { class: 'ab-pillar-more', text: 'Подробнее →' }),
        ]))),

        bloc({
          id: 'community', numar: '01', eticheta: 'Сообщество',
          titlu: 'Среда, где отвечают за свои слова',
          intro: 'Идея публикуется с входом, целью и стопом, а исход решают участники и '
            + 'цена — не автор. Поэтому история каждого видна, и репутация здесь чего-то стоит.',
          functii: COMUNITATE,
        }),

        bloc({
          id: 'screener', numar: '02', eticheta: 'Скринер',
          titlu: 'Весь рынок на одном экране',
          intro: 'Профессиональный крипто-скринер прямо в браузере: десятки живых графиков '
            + 'одновременно, крупные заявки в стакане и автопоиск ситуаций для скальпинга.',
          functii: SCREENER,
        }),

        bloc({
          id: 'preplay', numar: '03', eticheta: 'Тренажёр',
          titlu: 'Тренировка на реальной истории',
          intro: 'Навык проверяется там, где нельзя подсмотреть. Сервер выдаёт реальный '
            + 'участок рынка и держит продолжение у себя, пока вы не ответите.',
          functii: ANTRENOR,
        }),

        el('section', { class: 'ab-block', id: 'pricing' }, [
          el('div', { class: 'ab-block-head' }, [
            el('span', { class: 'ab-num', text: '04' }),
            el('span', { class: 'ab-tag', text: 'Тарифы' }),
          ]),
          el('h2', { class: 'ab-h2', text: 'Сколько это стоит' }),
          el('p', { class: 'ab-intro', text: 'Нисколько. Проект живёт не на подписках, '
            + 'поэтому платить не за что: ни за скринер, ни за сообщество, ни за тренажёр. '
            + 'Карта не нужна, пробного периода нет — потому что нет и платного.' }),

          el('div', { class: 'ab-plans' }, TARIFE.map((t) => el('div', {
            class: `ab-plan${t.evidentiat ? ' hot' : ''}`,
          }, [
            el('span', { class: 'ab-plan-t', text: t.titlu }),
            el('span', { class: 'ab-plan-p', text: t.pret }),
            el('span', { class: 'ab-plan-s', text: t.sub }),
            el('div', { class: 'ab-plan-list' }, t.puncte.map((p) => el('div', { class: 'ab-plan-li' }, [
              icon('check', 11), el('span', { text: p }),
            ]))),
            el('button', { class: `btn${t.evidentiat ? ' primary' : ''}`, text: t.actiune[0], onclick: t.actiune[1] }),
          ]))),

          el('p', { class: 'ab-note' }, [
            icon('info', 12),
            el('span', { text: 'Если когда-нибудь появится платная часть, она будет '
              + 'объявлена заранее в «Обновлениях», а то, что уже бесплатно, таким и останется.' }),
          ]),
        ]),

        el('section', { class: 'ab-cta' }, [
          el('h2', { class: 'ab-h2', text: 'Хватит гадать. Начните смотреть.' }),
          el('p', { class: 'ab-intro', text: 'Скринер открывается сразу — без аккаунта и '
            + 'без карты. Аккаунт нужен, только когда захотите писать.' }),
          el('div', { class: 'ab-hero-act' }, [
            el('button', {
              class: 'btn primary', text: 'Открыть скринер',
              onclick: () => { location.href = '/screener/coins/'; },
            }),
            el('button', {
              class: 'btn', text: 'Правила и политика данных',
              onclick: () => { location.href = '/rules/'; },
            }),
          ]),
        ]),
      ]),
    ]);
    host.append(this.root);
    this.#anima();
  }

  /**
   * Apariţia la derulare şi numărătoarea cifrelor.
   *
   * Totul e opţional prin construcţie: dacă nimic nu rulează, elementele rămân la
   * starea finală şi pagina se citeşte întreagă. De aceea clasa adăugată e „vizibil",
   * nu una care ascunde — un `IntersectionObserver` care nu porneşte n-ar trebui să
   * lase pagina goală.
   *
   * `prefers-reduced-motion` opreşte tot: cine a cerut sistemului mai puţină mişcare
   * n-a cerut-o doar pentru alte site-uri.
   */
  #anima() {
    const linisteste = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const tinte = this.root.querySelectorAll('.ab-pillar, .ab-feat, .ab-plan, .ab-stat, .ab-block-head, .ab-h2, .ab-intro');
    if (linisteste) {
      this.root.classList.add('fara-miscare');
      tinte.forEach((t) => t.classList.add('vizibil'));
      return;
    }

    tinte.forEach((t) => t.classList.add('de-aratat'));
    this.observer = new IntersectionObserver((intrari) => {
      for (const intrare of intrari) {
        if (!intrare.isIntersecting) continue;
        // Decalajul se calculează pe rândul curent, nu pe toată pagina: altfel al
        // treizecilea card ar aştepta trei secunde după ce a intrat deja în ecran.
        const vecini = [...intrare.target.parentElement.children].indexOf(intrare.target);
        intrare.target.style.transitionDelay = `${Math.min(vecini, 5) * 70}ms`;
        intrare.target.classList.add('vizibil');
        this.observer.unobserve(intrare.target);
      }
    }, { root: this.root, rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    tinte.forEach((t) => this.observer.observe(t));

    // Plasă de siguranţă. Comentariul de mai sus spune că starea implicită e cea finală,
    // dar din clipa în care JavaScript-ul adaugă `de-aratat` asta nu mai e adevărat: un
    // observator care nu porneşte ar lăsa pagina goală. După patru secunde arătăm tot ce
    // a rămas ascuns — animaţia e un ornament, textul nu.
    this.plasa = setTimeout(() => {
      this.root.querySelectorAll('.de-aratat:not(.vizibil)').forEach((t) => t.classList.add('vizibil'));
    }, 4000);

    this.#numara();
  }

  /** Cifrele urcă până la valoarea lor când banda intră în ecran. */
  #numara() {
    const banda = this.root.querySelector('.ab-stats');
    if (!banda) return;
    const obs = new IntersectionObserver((intrari) => {
      if (!intrari.some((i) => i.isIntersecting)) return;
      obs.disconnect();
      for (const nod of banda.querySelectorAll('.ab-stat-n')) {
        const tinta = nod.dataset.tinta || '';
        const numar = parseInt(tinta.replace(/\D/g, ''), 10);
        if (!Number.isFinite(numar) || numar === 0) continue;   // „—" şi „0" n-au ce urca
        const sufix = tinta.replace(/[\d]/g, '');
        const start = performance.now();
        const durata = 900;
        const pas = (acum) => {
          const t = Math.min(1, (acum - start) / durata);
          // Frânare la final: o numărătoare liniară arată mecanic.
          const usor = 1 - (1 - t) ** 3;
          nod.textContent = `${Math.round(numar * usor)}${sufix}`;
          if (t < 1) requestAnimationFrame(pas);
        };
        nod.textContent = `0${sufix}`;
        requestAnimationFrame(pas);
      }
    }, { root: this.root, threshold: 0.4 });
    obs.observe(banda);
    this.observerCifre = obs;
  }

  unmount() {
    clearTimeout(this.plasa);
    this.observer?.disconnect();
    this.observerCifre?.disconnect();
    this.root?.remove();
  }
}
